import request from "@/utils/request";

// 获取登录用户信息
export function getInfo() {
  return request({
    url: "/system/user/getInfo",
    method: "get",
  });
}

// 获取未读通知数量
export function getNotifyCount() {
  return request({
    url: '/system/notify/count',
    method: 'get'
  })
}

// 获取通知列表
export function getNotifyPage(query) {
  return request({
    url: '/system/notify/page',
    method: 'get',
    params: query
  })
}

// 获取通知详情
export function getNotifyDetail(id) {
  return request({
    url: `/system/notify/${id}`,
    method: 'get'
  })
}

// 删除已读通知
export function deleteReadNotifications() {
  return request({
    url: '/system/notify/delete/readAll',
    method: 'delete'
  })
}

// 删除单个通知
export function deleteNotify(id, isMine) {
  return request({
    url: `/system/notify/${id}/${isMine}`,
    method: 'delete'
  })
}

// 一键已读通知
export function readAllNotifications() {
  return request({
    url: '/system/notify/readAll',
    method: 'put'
  })
}